module.exports = __webpack_public_path__ + "static/media/BMU.fee87028.png";